export const INITIAL_STATE = {
  credentials: {
    partnerAccessKey: '',
    userIdentityToken: '',
  },
  user: {
    uuid: '',
  },
  savingPlan: {},
  product: {
    productList: [],
    productOffers: [],
    productOffer: {},
    productDetail: {},
  },
  partner: {
    saveLaterTitle: '',
    saveLaterSubtitle: '',
  },
  folio: {},
  collections: {
    collectionsList: [],
    collectionDetail: {},
    userCollectionDetail: {},
    collectionAccept: {},
  },
  cancelRequests: {
    cancelRequestsList: [],
    cancelRequestsDetail: {},
  },
  savingGoal: {},
  savingGoals: [],
  taxStatuses: [],
  bankDetails: {},
  occupations: [],
  mandates: [],
  transactions: [],
  kyc: {},
  admin: {},
  adminCredentials: {},
  adminUsers: [],
  adminProducts: [],
  adminOffer: {
    offerList: [],
    offerDetail: {},
  },
  adminGoals: [],
  adminTransactions: {},
  adminPayments: [],
  adminPayment: {},
  adminAgents: {},
  adminPartners: {},
  checkout: {
    checkoutDetail: {},
    checkoutPayment: {},
    checkoutPaymentSip: {},
  },
};
